/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PostAddCompanionRequestCompanionsInner } from './postAddCompanionRequestCompanionsInner';

export interface PostAddCompanionRequest {
  /**
   * journeyID
   */
  journeyId: string;
  /**
   * 検索方法コード order:予約 eTicket:航空券
   */
  searchType: PostAddCompanionRequest.SearchTypeEnum;
  /**
   * 同行者リスト
   */
  companions: Array<PostAddCompanionRequestCompanionsInner>;
}
export namespace PostAddCompanionRequest {
  export type SearchTypeEnum = 'order' | 'eTicket';
  export const SearchTypeEnum = {
    Order: 'order' as SearchTypeEnum,
    ETicket: 'eTicket' as SearchTypeEnum,
  };
}
